<template>
    <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0H14V2H2V14H0V0Z"
            fill="#27292B"
        />
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
